/**
 *      PACKAGE SEARCH PARAMETERS INSTRUCTIONS:
 Example url:
 /house-land/house-land-packages/?price=400000&price=700000&land=345&land=800&bath=2&builder=carlisle+homes&bed=3

 Parameters:
 Parameters can be used in any combination and any order. Invalid parameters are ignored

 price = 'Price Range'
 must be included twice, first is minimum, second is maximum.
 (will adjust to max/min bounds if paramaters are outside of them)

 land = 'Land Size'
 must be included twice, first is minimum, second is maximum.
 (will adjust to max/min bounds if paramaters are outside of them)

 bed = 'Bedrooms'
 single digit number, corresponds to that number +, e.g. 2 = 2+ Bedrooms
 (1 is all, or just leave this paramater out)
 must be a positive number

 */


import React from 'react';
import $ from 'jquery';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

let sources = require('../../config.json');
let priceFormat = wNumb({
	prefix: '$',
	decimals: 0,
	thousand: ','
});
// let search = 0;

class PackageSearchBar extends React.Component {

	constructor(props) {
		super(props);

		var d = new Date();
		this.searchfields_url = sources.searchfields + "?ts=" + d.getTime();

		let p = this.props.search;
		let urlParams = {price: null, land: null, frontage: null, bed: null};

		if ('price' in p && p.price.length === 2) {
			urlParams.price = {start: p.price[0], end: p.price[1]};
		}
		if ('land' in p && p.land.length === 2) {
			urlParams.land = {start: p.land[0], end: p.land[1]};
		}
		if ('bed' in p && p.bed.length === 2) {
			urlParams.bed = {start: p.bed[0], end: p.bed[1]};
		}
		if ('frontage' in p && p.frontage.length === 2) {
			urlParams.frontage = {start: p.frontage[0], end: p.frontage[1]};
		}

		this.state = {
			onSearchClicked: props.onSearchClick,
			onResetClicked: props.onResetClick,
			urlParams: urlParams,
			priceBounds: { min: 460, max: 610 },
			priceVal: { start: 300000, end: 600000 },
			priceOpts: { step: 25000, margin: 25000	},
			priceSlider: null,
			landBounds: { min: 200, max: 600 },
			landVal: { start: 200, end: 600	},
			landOpts: { step: 20, margin: 20 },
			landSlider: null,
			frontageBounds: { min: 8, max: 16 },
			frontageVal: { start: 8, end: 16 },
			frontageOpts: { step: 1, margin: 1 },
			frontageSlider: null,
			bedBounds: { min: 2, max: 5 },
			bedVal: { start: 2, end: 5 },
			bedOpts: { step: 1, margin: 0 },
			bedSlider: null,
			accordion: true
		};

		this.landSliderUpdate       = this.landSliderUpdate.bind(this);
		this.priceSliderUpdate      = this.priceSliderUpdate.bind(this);
		this.bedSliderUpdate        = this.bedSliderUpdate.bind(this);
		this.frontageSliderUpdate   = this.frontageSliderUpdate.bind(this);
		this.onSearchClickEvent = this.onSearchClickEvent.bind(this);
		this.onSearchResetEvent = this.onSearchResetEvent.bind(this);
		this.initializeSliders  = this.initializeSliders.bind(this);
		this.onInitializeEvent  = this.onInitializeEvent.bind(this);
	}

	componentDidMount() {
		$.ajax({url: this.searchfields_url, dataType: 'json'}).done(function (search) {

			let newLand = {start: search.area.min, end: search.area.max};
			if (this.state.urlParams.land !== null) {
				newLand = this.state.urlParams.land;
			}

			let newPrice = {start: search.price.min, end: search.price.max};
			if (this.state.urlParams.price !== null) {
				newPrice = this.state.urlParams.price;
			}

			let newFrontage = {start: search.frontage.min, end: search.frontage.max};
			if (this.state.urlParams.frontage !== null) {
				newFrontage = this.state.urlParams.frontage;
			}

			let newBed = {start: search.bed.min, end: search.bed.max};
			if (this.state.urlParams.bed !== null) {
				newBed = this.state.urlParams.bed;
			}

			let newState = Object.assign(this.state, {
				priceBounds: search.price,
				priceVal: newPrice,
				landBounds: search.area,
				landVal: newLand,
				frontageBounds: search.frontage,
				frontageVal: newFrontage,
				bedBounds: search.bed,
				bedVal: newBed,
			});
			this.setState(newState);

			this.initializeSliders();
			this.onInitializeEvent();
		}.bind(this));
	}

	initializeSliders() {
		// Land Slider
		let landSlider = document.getElementById('slider--land');
		noUiSlider.create(landSlider, {
			connect: true,
			start: [this.state.landVal.start, this.state.landVal.end],
			margin: this.state.landOpts.margin,
			step: this.state.landOpts.step,
			range: this.state.landBounds,
			format: wNumb({
				decimals: 0
			})
		});

		// Display the slider value
		landSlider.noUiSlider.on('update', this.landSliderUpdate);

		// Price Slider
		let priceSlider = document.getElementById('slider--price');
		noUiSlider.create(priceSlider, {
			connect: true,
			start: [this.state.priceVal.start, this.state.priceVal.end],
			margin: this.state.priceOpts.margin,
			step: this.state.priceOpts.step,
			range: this.state.priceBounds,
			format: wNumb({
				decimals: 0
			})
		});

		// Display the slider value
		priceSlider.noUiSlider.on('update', this.priceSliderUpdate);

		// Bed Slider
		let bedSlider = document.getElementById('slider--beds');
		noUiSlider.create(bedSlider, {
			connect: true,
			start: [this.state.bedVal.start, this.state.bedVal.end],
			margin: this.state.bedOpts.margin,
			step: this.state.bedOpts.step,
			range: this.state.bedBounds,
			format: wNumb({
				decimals: 0
			})
		});

		// Display the slider value
		bedSlider.noUiSlider.on('update', this.bedSliderUpdate);

		// Frontage Slider
		let frontageSlider = document.getElementById('slider--frontage');
		noUiSlider.create(frontageSlider, {
			connect: true,
			start: [this.state.frontageVal.start, this.state.frontageVal.end],
			margin: this.state.frontageOpts.margin,
			step: this.state.frontageOpts.step,
			range: this.state.frontageBounds,
			format: wNumb({
				decimals: 0
			})
		});

		// Display the slider value
		frontageSlider.noUiSlider.on('update', this.frontageSliderUpdate);

		// Store sliders into state
		let newState = Object.assign(this.state, {
			priceSlider: priceSlider,
			landSlider: landSlider,
			bedSlider: bedSlider,
			frontageSlider: frontageSlider
		});
		this.setState(newState);
	}

	landSliderUpdate(values) {
		let newState = Object.assign(this.state, {
			landVal: {
				start: values[0],
				end: values[1]
			}
		});
		this.setState(newState);
	}

	priceSliderUpdate(values) {
		let newState = Object.assign(this.state, {
			priceVal: {
				start: values[0],
				end: values[1]
			}
		});
		this.setState(newState);
	}

	bedSliderUpdate(values) {
		let newState = Object.assign(this.state, {
			bedVal: {
				start: values[0],
				end: values[1]
			}
		});
		this.setState(newState);
	}

	frontageSliderUpdate(values) {
		let newState = Object.assign(this.state, {
			frontageVal: {
				start: values[0],
				end: values[1]
			}
		});
		this.setState(newState);
	}

	onSearchResetEvent() {
		if (this.state.onResetClicked !== null) {
			this.state.onResetClicked();
		}
		let newState = Object.assign(this.state, {
			priceVal: {
				start: this.state.priceBounds.min,
				end: this.state.priceBounds.max
			},
			landVal: {
				start: this.state.landBounds.min,
				end: this.state.landBounds.max
			},
			frontageVal: {
				start: this.state.frontageBounds.min,
				end: this.state.frontageBounds.max
			},
			bedVal: {
				start: this.state.bedBounds.min,
				end: this.state.bedBounds.max
			},
		});
		this.setState(newState);

		this.state.landSlider.noUiSlider.set([
			this.state.landVal.start,
			this.state.landVal.end,
		]);
		this.state.priceSlider.noUiSlider.set([
			this.state.priceVal.start,
			this.state.priceVal.end,
		]);
		this.state.frontageSlider.noUiSlider.set([
			this.state.frontageVal.start,
			this.state.frontageVal.end,
		]);
		this.state.bedSlider.noUiSlider.set([
			this.state.bedVal.start,
			this.state.bedVal.end,
		]);
	}

	onSearchClickEvent() {
		if (this.state.onSearchClicked !== null) {
			let data = {
				price: this.state.priceVal,
				area: this.state.landVal,
				frontage: this.state.frontageVal,
				bed: this.state.bedVal
			};
			this.state.onSearchClicked(data);
		}
	}

	onInitializeEvent() {
		if ( this.state.urlParams.price !== null || this.state.urlParams.land !== null || this.state.urlParams.frontage !== null || this.state.urlParams.bed !== null ) {
			this.onSearchClickEvent();
		}
	}

	accordionToggle() {
		$('.accordion__content').stop(true).slideToggle('slow');
		$('.accordion__toggle').toggleClass('open');
	}

	render() {
		let priceStart = priceFormat.to(parseInt(this.state.priceVal.start, 10));
		let priceEnd = priceFormat.to(parseInt(this.state.priceVal.end, 10));
		return (
			<div className="filter land__filter" id="searchBox">
				<div className="filter__header">
					<div className="cf">
						<div className="filter-toggle accordion__toggle open" onClick={this.accordionToggle}>
							<img className="toggle__down" src="https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/assets/images/chevron-down--grey.svg" alt="" width="15px"/>
							<img className="toggle__up" src="https://storage.googleapis.com/hollandpark.data.insiteinteractive.com.au/assets/images/chevron-up--grey.svg" alt="" width="15px"/>
							<span>Filter Results</span>
						</div>

						<div className="link__filter--reset" id="filter--reset" onClick={this.onSearchResetEvent}>Reset Filter</div>
						<div className="clear-div"></div>
					</div>
				</div>
				<div className="filter__content cf accordion__content ">
					<div className="flex-grid--md cf">
						<div className="filter__group left flex-col--md">
							<div className="filter__group--col">
								<div className="range__slider range__slider--price">
									<div className="cf">
										<div className="filter__label slider__label"> $ Price</div>
										<div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--price">

										</div>

										<div className="slider__values">
											<span id="lower-value--price">{priceStart}</span> to
											<span id="upper-value--price"> {priceEnd}</span></div>
									</div>
								</div>

								<div className="range__slider range__slider--price">
									<div className="cf">
										<div className="filter__label slider__label"> Bedrooms</div>
										<div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--beds">

										</div>

										<div className="slider__values">
											<span id="lower-value--price">{this.state.bedVal.start}</span> to
											<span id="upper-value--price"> {this.state.bedVal.end}</span></div>
									</div>
								</div>
							</div>
						</div>
						<div className="filter__group left flex-col--md">
							<div className="filter__group--col beds-baths--filter">
								<div className="range__slider range__slider--price">
									<div className="cf">
										<div className="filter__label slider__label"> Land Size</div>
										<div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--land">

										</div>

										<div className="slider__values">
											<span className="land-size" id="lower-value--land">{this.state.landVal.start}</span>m<sup>2</sup> to
											<span className="land-size" id="upper-value--land"> {this.state.landVal.end}</span>m<sup>2</sup>
										</div>
									</div>
								</div>

								<div className="range__slider range__slider--price">
									<div className="cf">
										<div className="filter__label slider__label"> Frontage</div>
										<div className="slider noUi-target noUi-ltr noUi-horizontal" id="slider--frontage">

										</div>

										<div className="slider__values">
											<span id="lower-value--price">{this.state.frontageVal.start}</span>m to
											<span id="upper-value--price"> {this.state.frontageVal.end}</span>m</div>
									</div>
								</div>
							</div>
						</div>
						<div className="filter__group left flex-col--md">
							<div className="filter__group--col builder--filter">
								<div className="btn__container" onClick={this.onSearchClickEvent}>
									<div className="btn btn__action btn__filter-search searching" id="filter-search-btn">
										Search<span className="searching-text">ing</span><span className="searching-dots">.</span><span className="searching-dots">.</span><span className="searching-dots">.</span>
									</div>
								</div>
							</div>
						</div>
						<div className="clear-div"></div>
					</div>
				</div>
			</div>
		);

	}
}

export default PackageSearchBar;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchBar.js
 **/